/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsUserSubscriptionListItem,
    MelcoModelsUserSubscriptionListItemFromJSON,
    MelcoModelsUserSubscriptionListItemFromJSONTyped,
    MelcoModelsUserSubscriptionListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsUserSubscriptionListItem
 */
export interface MelcoModelsGenericList1MelcoModelsUserSubscriptionListItem {
    /**
     * 
     * @type {Array<MelcoModelsUserSubscriptionListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserSubscriptionListItem
     */
    list: Array<MelcoModelsUserSubscriptionListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserSubscriptionListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsUserSubscriptionListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsUserSubscriptionListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsUserSubscriptionListItem {
    return MelcoModelsGenericList1MelcoModelsUserSubscriptionListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsUserSubscriptionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsUserSubscriptionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsUserSubscriptionListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsUserSubscriptionListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsUserSubscriptionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsUserSubscriptionListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


